package com.essntl.features.address.data.supabase

import com.essntl.core.supabase.SupabaseDataSource
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single(binds = [AddressSupabaseDataSource::class])
internal class AddressSupabaseDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<AddressDto> {
    override val tableName: String = "address"
}
